module.exports = __webpack_public_path__ + "img/tu-6.faaf4e4d.png";